export default "__VITE_ASSET__DEobEIvz__"